import { Component, OnInit, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";

@Component({
  selector: "app-ged",
  templateUrl: "./ged.component.html",
  styleUrls: ["./ged.component.scss"],
})
export class GedComponent implements OnInit {
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "ged";
  itemsRole: any;
  itemsSpecialites: any;
  dateNais: any;
  bsValue: Date;
  ListNoParentFonctionnalites: any[];
  searchKey: any;
  itemsFiliale: any[];
  filiale_id: any;

  dateDebut: Date;
  dateFin: Date;
  filterDescription: string = '';
  filterFormat: string = '';

  documentTypes = [
    { value: 'etat_compta',                  libelle: 'État comptable (PDF)' },
    { value: 'etat_compta_excel',            libelle: 'État comptable (Excel)' },
    { value: 'reglement_presta',             libelle: 'Bordereau règlement (PDF)' },
    { value: 'reglement_presta_global',      libelle: 'Bordereaux règlements global (PDF)' },
    { value: 'reglement_presta_excel',       libelle: 'Bordereau règlement (Excel)' },
    { value: 'reglement_presta_global_excel', libelle: 'Bordereaux règlements global (Excel)' },
  ];
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
  ) {
    this.user = this.authService.getCurrentUser();
    this.filiale_id = this.user.filiale_id;
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.getItems();
  }
  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = "";
  }

  openModal(data: any, template: TemplateRef<any>) {
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      id: 1,
      class: "modal-md",
    };
    this.itemToSave = {};
    if (data) {
      console.info("data", data);
      // Lorsque nous sommes en modification
      // this.bsValue = data.dateNais
      this.itemToSave = Object.assign({}, data);
      if (data.parentId) {
        this.itemToSave.parentId = data.parentId;
      }
    }

    this.modalRef = this.modalService.show(template, config);
  }

  getItems() {
    let request: any = {
      user_id:    this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      search_key: this.searchKey || undefined,
      data:       {},
      index:      this.currentPage,
      size:       this.itemsPerPage,
    };

    if (this.dateDebut) request.date_debut = this.dateDebut;
    if (this.dateFin)   request.date_fin   = this.dateFin;

    this.busyGet = this.restClient
      .post(this.endPoint + "/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            let items = res["items"] as any[];

            // Filtres client-side : description et format
            if (this.filterDescription) {
              items = items.filter(it => this.matchesDescriptionFilter(it.description));
            }
            if (this.filterFormat === 'excel') {
              items = items.filter(it => this.isExcel(it));
            } else if (this.filterFormat === 'pdf') {
              items = items.filter(it => !this.isExcel(it));
            }

            this.items      = items;
            this.totalItems = res["count"];
          } else {
            this.items = [];
            this.totalItems = 0;
          }
        },
        (err) => {},
      );
  }

  matchesDescriptionFilter(description: string): boolean {
    if (!this.filterDescription) return true;
    const f = this.filterDescription;
    if (f === 'reglement_presta') {
      // seuls les PDFs par règlement individuel (ex: reglement_presta_42)
      return /^reglement_presta_\d+$/.test(description || '');
    }
    if (f === 'reglement_presta_excel') {
      return /^reglement_presta_\d+_excel$/.test(description || '');
    }
    return description === f;
  }

  isExcel(item: any): boolean {
    const url: string = item.image_url || '';
    return url.toLowerCase().endsWith('.xlsx') || url.toLowerCase().endsWith('.xls');
  }

  getDocumentTypeLabel(description: string): string {
    if (!description) return '—';
    if (description === 'etat_compta')                   return 'État comptable PDF';
    if (description === 'etat_compta_excel')             return 'État comptable Excel';
    if (description === 'reglement_presta_global')       return 'Règlements global PDF';
    if (description === 'reglement_presta_global_excel') return 'Règlements global Excel';
    if (description.endsWith('_excel'))                  return 'Bordereau Excel';
    if (description.startsWith('reglement_presta_'))     return 'Bordereau PDF';
    return description;
  }

  resetFiltres() {
    this.searchKey         = '';
    this.filterDescription = '';
    this.filterFormat      = '';
    this.dateDebut         = null;
    this.dateFin           = null;
    this.currentPage       = 0;
    this.getItems();
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: this.currentPage,
      size: this.itemsPerPage,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => {},
      );
  }

  confirmDelete(item) {
    Swal.fire({
      title: "Suppression",
      text: "Vous êtes sur le point de supprimer un élément. Voulez-vous poursuivre cette action ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3f51b5",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        this.deleteItem(item);
      }
    });
  }

  deleteItem(obj) {
    var request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: [obj],
    };

    this.busyGet = this.restClient
      .post(this.endPoint + "/delete", request)
      .subscribe(
        (res) => {
          console.info(res);
          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center",
            );

            this.currentPage = 0;
            this.getItems();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center",
              );
            }
          }
        },
        (err) => {
          console.info("Error occured", err);
          this.utilities.showNotification(
            "snackbar-danger",
            err || this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center",
          );
        },
      );
  }

  onSelectDate(event) {
    if (event) {
      ((this.dateNais = moment(event).format("DD/MM/YYYY")),
        console.info("dateNais", this.dateNais));
    }
  }
  toggleIsMedecin(itemToToggle) {
    itemToToggle.isMedecin = !itemToToggle.isMedecin;
  }
  changePaginationSize($event) {
    if ($event) {
      this.currentPage = 0;
      this.itemsPerPage = parseInt($event);
    }
    this.getItems();
  }

  ngOnInit() {
    this.resetForm();
    this.getItems();
    this.getItemsFiliale();
  }
}
